"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/PatientTable/SelectionBar.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _format = require('./format');

/* The left of the selection bar, in both tables (D-84): what is selected,
 * "Select all N matching" to go on from the page, a quiet note (patients
 * left out, the cap, a patient just created) and Clear. */
 const SelectionSummary






 = ({ summary, extra, isDisabled = false, onSelectAll, onClear }) => (
  _react2.default.createElement(_react2.default.Fragment, null
    , _react2.default.createElement('span', { className: "recipients-toolbar--count", 'aria-live': "polite", __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}},  summary.count )
    ,  summary.allOf !== undefined && (
      _react2.default.createElement('button', { type: "button", className: "recipients-toolbar--clear", disabled: isDisabled, onClick: onSelectAll, __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}, "Select all "
          ,  _format.formatCount.call(void 0, summary.allOf) , " matching"
      )
    )
    ,  summary.note && _react2.default.createElement('span', { className: "recipients-toolbar--note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}},  summary.note ) 
    ,  extra && _react2.default.createElement('span', { className: "recipients-toolbar--note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}},  extra ) 
    , _react2.default.createElement('button', { type: "button", className: "recipients-toolbar--clear", disabled: isDisabled, onClick: onClear, __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}, "Clear")
  )
); exports.SelectionSummary = SelectionSummary




















/* The selection bar takes the toolbar's place while patients are selected
 * (direction C, c-pt2, c-pt3, c-pt3cap): the shared summary on the left,
 * "Select all N matching" to go on from a ticked page, and the actions on
 * the right. Members tag and add to broadcasts; only admins archive and
 * restore (D-1, D-10). */
const SelectionBar = ({
  view, summary, isAdmin, isBusy, isWaiting, hasCountFailed, onRetryCount,
  onSelectAll, onClear, onTag, onBroadcast, onArchive, onRestore,
}) => {
  const isArchivedView = view === 'archived'
  const isHeld = isBusy || isWaiting
  return (
    _react2.default.createElement('div', { role: "toolbar", 'aria-label': "Selected patients" , className: "recipients-toolbar recipients-toolbar--selection dir-selection"  , 'aria-busy': isBusy || undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}
      , _react2.default.createElement(exports.SelectionSummary, { summary: summary, onSelectAll: onSelectAll, onClear: onClear, __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}} )
      , _react2.default.createElement('span', { className: "recipients-toolbar--grow", __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}} )
      , _react2.default.createElement('div', { className: "dir-selection--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}
        ,  hasCountFailed && (
          _react2.default.createElement('span', { className: "recipients-toolbar--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}, "Couldn't count these patients."
               ,  ' ' 
            , _react2.default.createElement('button', { type: "button", className: "recipients-toolbar--clear", onClick: onRetryCount, __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}, "Try again" )
          )
        )
        ,  isArchivedView
          ? (
              _react2.default.createElement(_react2.default.Fragment, null
                , _react2.default.createElement('span', { className: "recipients-toolbar--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}
                  ,  isAdmin ? 'Archived patients can\'t be added to campaigns' : 'Only admins can restore' 
                )
                ,  isAdmin && (
                  _react2.default.createElement('button', { type: "button", className: "recipients-toolbar--action recipients-toolbar--action--primary" , disabled: isHeld, onClick: onRestore, __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}, "Restore"

                  )
                )
              )
            )
          : (
              _react2.default.createElement(_react2.default.Fragment, null
                , _react2.default.createElement('span', { className: "recipients-toolbar--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}
                  ,  isAdmin ? `Up to ${_format.formatCount.call(void 0, _format.MAX_PER_ACTION)} per action` : 'Only admins can archive' 
                )
                , _react2.default.createElement('button', { type: "button", className: "recipients-toolbar--action", disabled: isHeld, onClick: onTag, __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}, "Add tag" )
                , _react2.default.createElement('button', {
                  type: "button",
                  className: "recipients-toolbar--action recipients-toolbar--action--primary" ,
                  disabled: isHeld,
                  onClick: onBroadcast, __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}
, "Add to campaign"

                )
                ,  isAdmin && (
                  _react2.default.createElement('button', { type: "button", className: "recipients-toolbar--action recipients-toolbar--action--danger" , disabled: isHeld, onClick: onArchive, __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}, "Archive"

                  )
                )
              )
            )
      )
    )
  )
}

exports. default = SelectionBar
